import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { StickerTexte } from '@components/sticker-texte/models';
import { ButtonComponent } from '@shared/components/button';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-sticker-texte',
  templateUrl: './sticker-texte.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, TitleComponent, ButtonComponent],
})
export class StickerTexteComponent extends AbstractDynamicComponent<StickerTexte> {
  protected readonly stickerOrientation = computed(() => {
    return `${this.data.sticker.rotation === 'left' ? -4 : 5}deg`;
  });
}
